export class Notifier {
  subscriptions: Function[] = [];

  addSubscription = (cb: Function) => {
    this.subscriptions.push(cb);
  };

  notifySubsciptions = () => {
    this.subscriptions.forEach((s) => s());
  };
}
